<template>
  <div
    v-if="!!versionHistory.length"
    class="VersionListing border-inverted-bottom-thick mt-3 pb-3"
  >
    <h2 class="mb-2 ml-2 font-weight-bold font-smaller">Version History</h2>
    <div class="ml-2 pl-0 font-smaller">
      <div v-for="version in versionHistory" :key="version.itemId">
        <div
          v-if="version.itemId === article.id"
          class="d-inline-block primary--text font-weight-bold"
        >
          {{ version.publishedDate | localDate }} Version {{ version.version }}
          {{
            version.status === "RETRACTED" && newArticleDetailsDisplay
              ? "(Retracted)"
              : ""
          }}
        </div>
        <div
          v-else-if="!newArticleDetailsDisplay"
          class="d-inline-block has-action"
        >
          <nuxt-link
            :to="`/engage/${partner}/article-details/${version.itemId}`"
            >{{ version.publishedDate | localDate }} Version
            {{ version.version }}</nuxt-link
          >
        </div>
        <div v-else class="d-inline-block has-action">
          <nuxt-link
            v-if="version.status !== 'RETRACTED'"
            :to="`/engage/${partner}/article-details/${version.itemId}`"
            >{{ version.publishedDate | localDate }} Version
            {{ version.version }}</nuxt-link
          >
          <span v-else
            >{{ version.publishedDate | localDate }} Version
            {{ version.version }}
            {{ version.status === "RETRACTED" ? "(Retracted)" : "" }}</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sorted from "~/plugins/utilities/sorted";
import mapFlags from "~/plugins/utilities/mapFlags";

export default {
  name: "VersionListing",
  props: {
    article: { type: Object, required: true },
  },
  computed: {
    ...mapFlags(["newArticleDetailsDisplay"]),
    partner() {
      return this.$config.partner;
    },
    versionHistory() {
      const { article } = this;
      const { versionHistory } = article;

      const history = versionHistory.map((versionRef) => {
        const version = parseInt(versionRef.version, 10);

        return { ...versionRef, version };
      });

      return (
        sorted(history, "version").reverse() || [
          {
            itemId: article.id,
            version: article.version,
            publishedDate: article.publishedDate,
          },
        ]
      );
    },
  },
};
</script>
